import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const XIconV2 = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 42}
          height={props.height ?? 40}
          viewBox="0 0 42 40"
          fill="none"
          {...props}
        >
          <Rect
            x="0.617188"
            y="0.744141"
            width="41"
            height="39"
            rx="8"
            fill="white"
            fillOpacity="0.85"
          />
          <Path
            d="M15.6239 31.0876L10.3139 25.7776L16.4408 19.6508L10.3511 13.561L14.6213 9.29081L20.711 15.3805L26.6522 9.43934L31.9622 14.7493L26.021 20.6905L32.0736 26.7431L27.8033 31.0133L21.7507 24.9607L15.6239 31.0876Z"
            fill={props.color ?? '#E2753A'}
          />
        </Svg>
      </View>
    );
  },
);

export { XIconV2 };
